import { logger } from "../../infrastructure/services/LoggerService";
import api from "../../plugins/api";
export class UserService {
    constructor(userRepository, notificationService) {
        Object.defineProperty(this, "userRepository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: userRepository
        });
        Object.defineProperty(this, "notificationService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notificationService
        });
    }
    // Account information methods
    async getAccountInfo() {
        try {
            const response = await api.get("/payment-manager/account-info");
            /* response.data example:
              {
                "success": true,
                "errorCode": 0,
                "calledApiErrorCode": "",
                "message": "Account information retrieved successfully",
                "result": {
                  "onboardingStatus": "Initialized",
                  "accountStatus": "Created",
                  "name": "opayaccount TEST 1",
                  "language": "fr-FR",
                  "email": "opayaccount+1@eudonet.com",
                  "logoUri": null
                },
                "errorResult": null
              }
            */
            logger.debug("Account info response:", response.data);
            // Return the API response result object directly
            return response.data.result;
        }
        catch (error) {
            logger.debug("Failed to fetch account info:", error);
            // no need to display an error message
            //this.notificationService.showError("Failed to fetch account information");
            throw error;
        }
    }
}
